(function (){
    'use strict';
    angular.module('elogbooks.admin.pcd-imports', []);
})();
